'use strict';

exports.__esModule = true;

var _modern = require('./modern');

Object.defineProperty(exports, 'QuerySubscription', {
  enumerable: true,
  get: function get() {
    return _modern.QuerySubscription;
  }
});
Object.defineProperty(exports, 'ReadyStateRenderer', {
  enumerable: true,
  get: function get() {
    return _modern.ReadyStateRenderer;
  }
});
Object.defineProperty(exports, 'Resolver', {
  enumerable: true,
  get: function get() {
    return _modern.Resolver;
  }
});


// WEBPACK FOOTER //
// ./~/found-relay/lib/index.js